<div class="user-list-wrap">
  <div class="user-tabs">
    <a class="user-tab" routerLink="/user" routerLinkActive="user-tab-active" [routerLinkActiveOptions]="{exact: true}">User List</a>
    <a class="user-tab" routerLink="/user/add-new-user" routerLinkActive="user-tab-active">Add new user</a>
  </div>

  <div class="row mt-4 flex">
    <div class="search-col">
      <div class="iq-search-bar">
        <form action="#" class="searchbox">
          <input type="text" #nameInput class="text search-input searchInner" (keyup)="filterByName($event)" placeholder="Search User By Name">
          <a class="search-link" href="javascript:void(0)">
            <i class="fa-solid fa-magnifying-glass" style="color:#000"></i>
          </a>
        </form>
      </div>
    </div>
    <div class="col-auto">
      <select class="form-control select" [(ngModel)]="selectFilterBy" (change)="onFilterChange()">
        <option value="none">All Filter</option>
        <option value="byCreatedDate">By Created Date </option>
      </select>
    </div>
    <div class="col-auto">
      <select class="form-control select" [(ngModel)]="selectRoleBy" (change)="onFilterChange()">
        <option value="none">All Roles</option>
        <option *ngFor="let role of userRoles" [value]="role">{{ role }}</option>
      </select>
    </div>
    <div class="col-auto">
      <select class="form-control select" [(ngModel)]="selectStatusBy" (change)="onFilterChange()">
        <option value="none">All Status</option>
        <option *ngFor="let status of userStatuses" [value]="status">{{ status }}</option>
      </select>
    </div>
    <div class="col-auto">
      <button class="btn applyBtn" (click)="resetSearch()">Reset</button>
    </div>
  </div>

  <table mat-table [dataSource]="users">
    <ng-container matColumnDef="No">
      <th mat-header-cell *matHeaderCellDef>No</th>
      <td mat-cell *matCellDef="let element; let i = index">{{ pageIndex * pageSize + i + 1 }}</td>
    </ng-container>

    <ng-container matColumnDef="Name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>

    <ng-container matColumnDef="Email">
      <th mat-header-cell *matHeaderCellDef>Email</th>
      <td mat-cell *matCellDef="let element">{{ element.email }}</td>
    </ng-container>

    <ng-container matColumnDef="MobileNo">
      <th mat-header-cell *matHeaderCellDef>Mobile Number</th>
      <td mat-cell *matCellDef="let element">{{ element.mobileNo }}</td>
    </ng-container>

    <ng-container matColumnDef="Role">
      <th mat-header-cell *matHeaderCellDef>Role</th>
      <td mat-cell *matCellDef="let element">{{ element.userRoles?.[0]?.userRole }}</td>
    </ng-container>

    <ng-container matColumnDef="CreatedDateTime">
      <th mat-header-cell *matHeaderCellDef>Created Date</th>
      <td mat-cell *matCellDef="let element">{{ element.createdDateTime | date:"MMMM d, y 'at' h:mm a" }}</td>
    </ng-container>

    <ng-container matColumnDef="Action">
      <th mat-header-cell *matHeaderCellDef>Action</th>
      <td mat-cell *matCellDef="let element">
        <div class="action-btns">
          <button type="button" class="btn action-btn update-btn" (click)="updateUser(element)">
            <i class="fa-solid fa-pen-to-square"></i> Update
          </button>
          <button type="button" class="btn action-btn delete-btn" (click)="deleteUser(element)">
            <i class="fa-solid fa-trash"></i> Delete
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator
    (page)="pageChangeEvent($event)"
    [length]="totalCount"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    showFirstLastButtons>
  </mat-paginator>

  <div class="delete-modal-backdrop" *ngIf="userToDelete" (click)="cancelDelete()">
    <div class="delete-modal" role="dialog" aria-modal="true" aria-labelledby="deleteModalTitle" (click)="$event.stopPropagation()">
      <div class="delete-modal-header">
        <h5 id="deleteModalTitle">Delete User</h5>
        <button type="button" class="delete-modal-close" aria-label="Close" (click)="cancelDelete()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="delete-modal-body">
        <i class="fa-solid fa-triangle-exclamation delete-modal-icon"></i>
        <p>Do you want to delete <strong>{{ userToDelete.name }}</strong> from our system?</p>
      </div>
      <div class="delete-modal-footer">
        <button type="button" class="btn delete-modal-cancel" [disabled]="deleting" (click)="cancelDelete()">Cancel</button>
        <button type="button" class="btn delete-modal-ok" [disabled]="deleting" (click)="confirmDelete()">
          {{ deleting ? 'Deleting...' : 'OK' }}
        </button>
      </div>
    </div>
  </div>
</div>
